<template>
  <div class="abilityList" >
    <!-- style="background-color: #f5f5f5; height: 100%" -->
    <div v-if="!isDetail" class="navigation" style="position:relative; height: 350px">
      <img v-show="!isDetail" src="../img/ability_banner.png" style="width: 100%;height: 100%" alt=""/>
      <span style="position: absolute; bottom: 190px; left: 280px;font-size:30px">{{$t('ability.title')}}</span>
      <span style="position: absolute; bottom: 125px; left: 280px;font-size:20px">{{$t('ability.search')}}</span>
      <div class="searchSceneAbility" style="position: absolute; bottom: 120px; left: 380px;">
          <el-autocomplete
            v-model="searchContent"
            :fetch-suggestions="querySearchAsync"
            :placeholder="$t('ability.searchPlaceholder')"
            @select="handleSelect"
            :clear-icon-click="clearSelect"
          ></el-autocomplete>
      </div>
    </div>

    <!-- <h-page-container v-if="pageState === 'list'"> -->
      <div class="showScene" v-show="!isDetail">
      <h-page-content >
        <div class="search-list-wrapper">
          <!-- 排序tags -->
          <h-layout-header class="tabClick">
            <div style="position: absolute;right: 25px; top:10px;">
              <img style="vertical-align: middle;" src="../img/attention.svg"/>
              <span style="vertical-align: middle;font-size: 14px;color: rgba(36,36,36,0.70);" >{{ $t('ability.total',{total:total}) }}</span>
            </div>
            <el-tabs v-model="sortType" @tab-click="getListByOrder">
              <el-tab-pane v-for="item in sortOrder"
                :key= "item.value"
                :label= "item.label"
                :name= "item.value"
              ></el-tab-pane>
            </el-tabs>
          </h-layout-header>


          <div  v-if="breadcrumbSelectedData && breadcrumbSelectedData.length" class="search-breadcrumb-wrapper">
            <el-breadcrumb separator="/">
            <div style="position: absolute;right: 30px;top:50px;font-size: 14px;color: rgba(36,36,36,0.70);" >
              <el-button type="link" @click="deleteAll()">{{ $t('ability.clearConditions') }}</el-button>
            </div>
              <el-breadcrumb-item>{{$t('ability.selectedConditions')}}</el-breadcrumb-item>
              <el-breadcrumb-item style="margin-top: -2px;">
                <div class="breadcrumb-tag-wrapper">
                  <span class="breadcrumb-tag one-line" :title="selectedTag.title" @click.stop="() => {}" v-for="selectedTag in breadcrumbSelectedData" :key="selectedTag.id">
                    <span class="breadcrumb-tag-text">{{selectedTag.title}}</span>
                    <div class="h-icon-close_sm breadcrumb-tag-close" @click="deleteSelected(selectedTag)"></div>
                  </span>
                </div>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div>

        <div class="search-filter-wrapper">
            <div class="filter-content-wrapper">
              <div class="filter-content-lable"> {{$t('ability.type')}}</div>
              <div style="width: calc(100% - 88px);">
              <div class="filter-content-selecte-wrapper" v-if="!isRadio">
                <div :class="(isSelectedAll ? 'selected-all-btn selected-all-btn_selected' : 'selected-all-btn')" @click="selectedAll">{{$t('ability.all')}}</div>
                <div class="selected-btns-wrapper" style="margin-top: -5px;">
                  <!-- 多选 -->
                  <div style="width: 100%;display: flex;padding-top: 4px;flex-wrap: wrap;">
                    <div v-for="item in listData" :key="item.value" style="margin: 0 8px;margin-bottom: 5px;margin-top: 5px;min-width: 64px;">
                      <el-checkbox
                        :indeterminate="item.isIndeterminate"
                        v-model="item.checkAll"
                        @change="handleCheckAllChange(item)"
                      >
                        <span style="">
                          <span style="vertical-align: middle;display: block;" class="one-line">{{ item.label }}</span>
                        </span>
                      </el-checkbox>
                        <img
                          v-if="item.children && item.children.length && !item.isOpenChildren"
                          @click.stop="openChildrenList(item)"
                          @mouseenter="hoverExtend(item)"
                          @mouseleave="noHoverExtend(item)"
                          style="vertical-align: bottom;cursor: pointer;"
                          :src="
                            item.isHoverExtend
                              ? require('../img/extend_icon_white.062b1d4b.svg')
                              : require('../img/extend_icon_b.527f7a5d.svg')
                          "
                        />
                        <img
                          v-if="item.children && item.children.length && item.isOpenChildren"
                          @click.stop="openChildrenList(item)"
                          @mouseenter="hoverExtend(item)"
                          @mouseleave="noHoverExtend(item)"
                          style="vertical-align: bottom;cursor: pointer;"
                          src="../img/extend_icon_b.527f7a5d.svg"
                        />
                        </span>
                    </div>
                    </div>
                </div>
            </div>
              <transition name="slide-fade">
                <div v-for="item in listData" :key="item.value" v-if="!isRadio && item.children && item.children.length && item.isOpenChildren" style="display: flex;min-height: 40px;background: #F7F8FF;padding: 7px 12px;border: 1px solid rgba(0,0,0,0.12);margin-top: 4px;">
                  <span style="padding-top: 4px;font-size: 14px;color: rgba(0,0,0,0.40);margin-right: 16px;">{{childLabel}}</span>
                  <!-- 子多选 -->
                  <div style="flex: 1;">
                    <el-checkbox-group v-model="item.checkedChildrenArr" @change="(value) => {handleCheckedChidlrenChange(value, item)}">
                      <el-checkbox v-for="childItem in item.children" :label="childItem.label" :key="childItem.value">{{childItem.label}}</el-checkbox>
                    </el-checkbox-group>
                  </div>
                </div>
              </transition>
            </div>
            </div>
          </div>
        <div v-if="sceneAbilityList.length === 0" style="margin-top: 150px; margin-left:600px; width: 204px; height: 204px">
          <h-empty :description="$t('h.common.noData')" />
        </div>
        <el-scrollbar wrap-class="list-scrollbar-wrap" v-show="sceneAbilityList.length != 0">
          <div class="appList">
            <template v-for="(abilityInfo, index) in sceneAbilityList">
              <div class="appCard" :key="abilityInfo.id" style="border-top-right-radius:10px;border-top-left-radius:10px;border-bottom-left-radius:10px;border-bottom-right-radius:10px;">
                <div class="cardInfo" @click="routerDetail(abilityInfo.id)">
                  <div class="infoTop">
                    <img v-if="abilityInfo.ico" :src="abilityInfo.ico"/>
                    <h-empty v-else style="background: #efefef">
                      <template #img>
                        <h-empty-default-image />
                      </template>
                    </h-empty>
                  </div>
                  <div class="infoEnd":title="abilityInfo.sceneAbilityName">
                    <div class="abilityName" :title="abilityInfo.sceneAbilityName">
                      {{ abilityInfo.abilityName }}
                    </div>
                    <div class="abilityDescription" :title="abilityInfo.description"> {{abilityInfo.description}}</div>
                    <div class="openWays">
                      <el-tag v-for="tag in abilityInfo.openWays" type="success">{{ tag.label }} </el-tag>
                    </div>
                     <img class="pic" src="../img/pic.svg"/>
                     <div class="read">
                        <img src="../img/reading.svg"/>
                        <span class="readNum">{{abilityInfo.viewNum}}</span>
                     </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </el-scrollbar>
      </h-page-content>
        <div class="table-pagination" v-if="total > 0">
          <el-pagination
           :current-page.sync="pageNo"
           @current-change="handleCurrentChange"
           :page-sizes="[6, 12, 24, 48]"
           :page-size="pageSize"
           layout="total,  prev, pager, next"
           :total="total">
          </el-pagination>
       </div>
      </div>
    <!-- </h-page-container> -->

  </div>
</template>
<script>
import {
  getSceneGroup,
  searchSceneList,
  getSceneInfoByGroupId,
} from "@/api";
export default {
  name: "abilityInfo",

  props: {
    isRadio: {
      type: Boolean,
      default: false,
    },
    typeCN: {
      type: String,
      default: "",
    },
    typeEN: {
      type: String,
      default: "",
    },
    businessFirstLoaded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      //hicoo-ai
      childLabel: "",
      //api接口展示相关字段
      isDetail: false,
      path: [
        {
          id: "",
          title: "",
        },
      ],
      sceneDescription: "",
      hostPath: "",
      isApiPage: true,
      //资源展示
      map: {
        title: "",
        html: "",
      },
      breadcrumbSelectedData: [],
      //总的资源列表
      resourceList: [],
      //当前选择的资源列表
      currResourceList: [],
      //搜索框
      searchContent: "",
      activeTab: "",
      sortType: 'default',
      sortOrder: [
        {
          value: "default",
          label: this.$t('ability.defaultSort'),
        },
        {
          value: "view",
          label: this.$t('ability.viewNum'),
        }
      ],
      openModels: [
        {
          value: "api",
          label: "API",
        },
        {
          value: "mq",
          label: this.$t('ability.mq'),
        },
        {
          value: "protocol",
          label: this.$t('ability.protocol'),
        },
        {
          value: "sdk&tool",
          label: this.$t('ability.sdk'),
        },
        {
          value: "resourcePack",
          label: this.$t('ability.resourcePack'),
        },
      ],
      currOpenModel: [],
      isShowOpemModel: false,
      docAnchorList: {
        title: "",
        anchorList: [],
      },
      docList: [],
      isgetDocTitile: false,

      pageState: "list",
      showLine: false,
      // 分页参数
      pageNo: 1,
      pageSize: 12,
      total: 0,
      checkAll: false,
      isIndeterminate: false,
      listData: [],

      //能力展示相关参数
      sceneAbilityList: [],
      abilityInfo: "",
    };
  },
  watch: {
    //////////hicoo-ai////////////////
    listData: {
      handler(newVal) {
        this.calcSelectedData();
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    //////////hicoo-ai////////////////
    isSelectedAll() {
      let haveChecked = false;
      this.listData.forEach((item) => {
        if (item.checkAll || item.isIndeterminate) {
          haveChecked = true;
        }
      });
      return !haveChecked;
    },
  },
  created() {},
  mounted() {
    this.getSceneGroupTreeNode();
    this.getSceneListByPage();
  },
  methods: {
    //hicoo-ai
    getSceneGroupTreeNode() {
      const param = {
        pageNo: 1,
        pageSize: 100,
      };
      const me = this;
      getSceneGroup(param)
        .then(function (response) {
          if (response.code === "0") {
            me.listData = response.data.data.list;
            //拼树
            const tree = me.getTreeNode(me.listData);
            me.listData = tree;
          }
        })
        .catch(function () {});
    },

    getTreeNode(data) {
      var result = [];
      for (let param of data) {
        if (param.parentId == 0) {
          var parent = {
            label: param.groupName,
            value: param.id,
            parentId: param.parentId,
            sort: 1,
            checkAll: false,
            isIndeterminate: false,
            isHoverExtend: false,
            isOpenChildren: false,
            checkedChildrenArr: [],
          };
          parent.children = this.getchilds(param.id, data);
          result.push(parent);
        }
      }
      return result;
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.handleSelect()
    },

    getchilds(id, array) {
      let childs = new Array();
      for (let arr of array) {
        //循环获取子节点
        if (arr.parentId == id) {
          childs.push({
            label: arr.groupName,
            value: arr.id,
            parentId: arr.parentId,
            sort: 0,
            checkAll: false,
            isIndeterminate: false,
            isHoverExtend: false,
            isOpenChildren: false,
            checkedChildrenArr: [],
            children: [],
            isChecked: false,
          });
        }
      }
      for (let child of childs) {
        //获取子节点的子节点
        let childscopy = this.getchilds(child.value, array); //递归获取子节点
        if (childscopy.length > 0) {
          child.children = childscopy;
        }
      }
      return childs;
    },

    selectedAll() {
      //清空面包屑中存在的数据
      this.breadcrumbSelectedData = []
      // 将所有选中清空
      this.listData.forEach((item) => {
        item.checkAll = false; // 非接口字段
        item.isIndeterminate = false; // // 非接口字段
        item.isHoverExtend = false; // 非接口字段
        item.isOpenChildren = false; // 非接口字段
        item.checkedChildrenArr = []; // 选中的子元素
        (item.children || []).forEach((childItem) => {
          childItem.isChecked = false;
        });
      });
      //分页获取应用场景
      this.getSceneListByPage();
    },

    handleCheckAllChange(value) {
      value.checkedChildrenArr = [];

      (value.children || []).forEach((childItem) => {
        childItem.isChecked = value.checkAll;
        value.checkAll && value.checkedChildrenArr.push(childItem.label);
      });
      value.isIndeterminate = false;
      this.listData.forEach((item) => {
        item.isOpenChildren = false;
      });
      if (value.checkAll) {
        value.isOpenChildren = true;
        this.childLabel = value.label + this.$t('ability.childrenType');
        //需要增加面包屑
        var s = {
          id: value.value,
          title: value.label,
        }
        if(this.breadcrumbSelectedData.map(tag => tag.id.indexOf(value.value) != -1)) {
          this.breadcrumbSelectedData = this.breadcrumbSelectedData.filter(tag => tag.id.indexOf(value.value) == -1);
        }
        this.breadcrumbSelectedData.push(s)
      } else{
        //当取消选中时，需要去除面包屑中的数据
        this.breadcrumbSelectedData = this.breadcrumbSelectedData.filter(tag => tag.id.indexOf(value.value) == -1);
      }
      this.breadcrumbSelectedData.sort(this.compare('id'));

      // 计算选中的，然后用于发请求
      let checkedObj = this.calcSelectedData();
      let checkedList = [];
      for (let cItem of checkedObj) {
        checkedList.push(cItem.valueArr);
      }
      if (checkedObj.length == 0 && this.searchContent == '') {
        this.getSceneListByPage();
        return;
      }
       else if (checkedList.length > 0) {
        this.getSceneInfoByGroupIds(checkedList);
        return
      }
      this.handleSelect();

    },
    compare(property){
      return function (a, b) {
        var value1 = a[property]
        var value2 = b[property]
        return value1 - value2;
      }
    },

    deleteAll() {
      this.breadcrumbSelectedData = []
      //清除listData中的所有选中项
      this.listData.forEach((item) =>{
        item.checkAll = false; // 非接口字段
        item.isIndeterminate = false; // // 非接口字段
        item.isHoverExtend = false; // 非接口字段
        item.isOpenChildren = false; // 非接口字段
        item.checkedChildrenArr = []; // 选中的子元素
        (item.children || []).forEach((childItem) => {
          childItem.isChecked = false;
        });
      })
      this.getSceneListByPage();
      return;
    },

    deleteSelected(pproperties){
      //根据id去掉面包屑中当前属性
      this.breadcrumbSelectedData = this.breadcrumbSelectedData.filter(tag => tag.id !== pproperties.id);
      if(this.breadcrumbSelectedData.length == 0) {
        //清除listData中的所有选中项
        this.listData.forEach((item) =>{
          item.checkAll = false; // 非接口字段
          item.isIndeterminate = false; // // 非接口字段
          item.isHoverExtend = false; // 非接口字段
          item.isOpenChildren = false; // 非接口字段
          item.checkedChildrenArr = []; // 选中的子元素
          (item.children || []).forEach((childItem) => {
            childItem.isChecked = false;
          });
        })
        this.getSceneListByPage();
        return;
      }
      let ids = [];
      var selectData = ''
      for (let cItem of this.breadcrumbSelectedData) {
        var idStr = cItem.id.split('|')
        //清除复选框中选中的内容
        selectData += cItem.title
      }
      this.listData.forEach((item) => {
        if(selectData.indexOf(item.label) == -1) {
          item.checkAll = false; // 非接口字段
          item.isIndeterminate = false; // // 非接口字段
          item.isHoverExtend = false; // 非接口字段
          item.isOpenChildren = false; // 非接口字段
          item.checkedChildrenArr = []; // 选中的子元素
          (item.children || []).forEach((childItem) => {
            childItem.isChecked = false;
          });
        }
      });
      let checkedObj = this.calcSelectedData();
      if (checkedObj.length == 0) {
        this.getSceneListByPage();
        return;
      }
      let checkedList = [];
      for (let cItem of checkedObj) {
        checkedList.push(cItem.valueArr);
      }

      this.getSceneInfoByGroupIds(checkedList);
    },

    handleCheckedChidlrenChange(value, item) {
      // 给选中的元素，isChildCheck属性为true，否则为false
      item.children.forEach((childData) => {
        childData.isChecked = value.includes(childData.label);
      });
      let checkedCount = value.length;
      this.$set(item, "checkAll", checkedCount === item.children.length);
      item.isIndeterminate =
        checkedCount > 0 && checkedCount < item.children.length;

      let checkedObj = this.calcSelectedData();
      this.breadcrumbSelectedData = []
      if (checkedObj.length == 0) {
        this.getSceneListByPage();
        return;
      }
      let checkedList = [];

      for (let cItem of checkedObj) {
        checkedList.push(cItem.valueArr);
        var temp = {
          id: cItem.valueArr.join("|"),
          title: cItem.label,
        }
        this.breadcrumbSelectedData.push(temp)
      }
      this.breadcrumbSelectedData.sort(this.compare('id'))
      this.getSceneInfoByGroupIds(checkedList);
    },

    getSceneInfoByGroupIds(param) {
      const me = this;
      var longParam = [];
      for(var p of param) {
        console.log(p.length)
        for (var index in p) {
          longParam.push(parseFloat(p[index]));
        }
      }

      let reqParam = {
        pageNo: me.pageNo,
        pageSize: me.pageSize,
        groupId: longParam,
        sortType: me.sortType,
        abilityName: me.searchContent
      };
      getSceneInfoByGroupId(reqParam)
        .then(function (response) {
          if (response.data.code == "0") {
            me.sceneAbilityList = response.data.data.list;
            for(var ab of me.sceneAbilityList) {
              let opemWays =[]
              ab.openModel.split(",").forEach(function (item) {
                opemWays.push(
                  me.openModels.filter((op) => {
                    return op.value.indexOf(item) > -1;
                  })[0]
                );
              });
              ab.openWays = opemWays;
            }
            me.total = response.data.data.total;
          }
        })
        .catch(function () {});
    },
    hoverExtend(item) {
      item.isHoverExtend = true;
    },
    noHoverExtend(item) {
      item.isHoverExtend = false;
    },
    // 展开子集
    openChildrenList(item) {
      this.listData.forEach((itemData) => {
        if (itemData.value === item.value) {
          itemData.isOpenChildren = !itemData.isOpenChildren;
        } else {
          itemData.isOpenChildren = itemData.value === item.value;
        }
      });
      this.childLabel = item.label + this.$t('ability.childrenType');
    },
    // 计算选中的元素，label和value，给到外部
    calcSelectedData() {
      let tagArr = [];
      this.listData.forEach((item) => {
        if (item.checkAll) {
          tagArr.push({
            label: item.label,
            valueArr: [item.value],
          });
          (item.children || []).forEach((childItem) => {
            tagArr[tagArr.length - 1].valueArr.push(childItem.value);
          });
        } else if (item.isIndeterminate) {
          tagArr.push({
            label: item.label + " | ",
            valueArr: [item.value],
          });
          (item.children || []).forEach((childItem) => {
            if (childItem.isChecked) {
              tagArr[tagArr.length - 1].label += childItem.label + "、";
              tagArr[tagArr.length - 1].valueArr.push(childItem.value);
            }
          });
        }
      });
      tagArr.forEach((tag) => {
        if (tag.label[tag.label.length - 1] === "、") {
          tag.label = tag.label.slice(0, tag.label.length - 1);
        }
      });
      return tagArr;
      // this.$emit("selectedCheckboxData", tagArr, this.typeCN);
    },
    ///////////////////////hicoo-ai/////////////////////////

    handleSelect() {
      let checkedObj = this.calcSelectedData();
      let checkedList = [];
      for (let cItem of checkedObj) {
        checkedList.push(cItem.valueArr);
      }
      if(checkedList.length > 0) {
        this.getSceneInfoByGroupIds(checkedList);
        return;
      }
      const me = this;
      let param = {
        pageNo: me.pageNo,
        pageSize: me.pageSize,
        abilityName: me.searchContent,
        sortType: me.sortType,
      };
      searchSceneList(param)
        .then(function (response) {
          if (response.data.code == "0") {
            me.sceneAbilityList = response.data.data.list;
            for(var ab of me.sceneAbilityList) {
              let opemWays =[]
              ab.openModel.split(",").forEach(function (item) {
                opemWays.push(
                  me.openModels.filter((op) => {
                    return op.value.indexOf(item) > -1;
                  })[0]
                );
              });
              ab.openWays = opemWays;
            }
            me.total = response.data.data.total;
          }
        })
        .catch(function () {});
    },
    clearSelect() {
      this.searchContent = ''
      // 计算选中的，然后用于发请求
      let checkedObj = this.calcSelectedData();
      let checkedList = [];
      for (let cItem of checkedObj) {
        checkedList.push(cItem.valueArr);
      }
      if(checkedList.length > 0) {
        this.getSceneInfoByGroupIds(checkedList);
        return;
      }
      this.getSceneListByPage();
    },
    querySearchAsync(queryString, cb) {

      if (queryString === "") {
        cb(null);
        return;
      }
      if (this.searchContent == "") {
        this.getSceneListByPage();
      }
      const req = {
        pageNo: 1,
        pageSize: 100,
        abilityName: queryString,
      };
      searchSceneList(req).then(function (response) {
        const me = this;
          if (response.data.code === "0") {
            var result = response.data.data.list;
            var rName = [];
            for (let r in result) {
              result[r].value = result[r].abilityName;
            }
            cb(result);
            me.total = response.data.data.total;
          }
        })
        .catch(function () {
           me.$message.error(me.$t("ability.searchFail"));
        });
    },

    //分页获取应用场景列表
    getSceneListByPage() {
      const me = this;
      me.isDetail = false;
      let param = {
        pageNo: me.pageNo,
        pageSize: me.pageSize,
        abilityName: me.searchContent,
        sortType: me.sortType,
      };

      searchSceneList(param)
        .then(function (response) {
          if (response.data.code === "0") {
            me.sceneAbilityList = response.data.data.list;

            for(var ab of me.sceneAbilityList) {
              let opemWays =[]
              ab.openModel.split(",").forEach(function (item) {
                opemWays.push(
                  me.openModels.filter((op) => {
                    return op.value.indexOf(item) > -1;
                  })[0]
                );
              });
              ab.openWays = opemWays;
            }
            me.total = response.data.data.total;
          } else {
            me.$message.error(
              me.$t(errorCodeKey(response.data.code)),
              me.$t("document.requestFail")
            );
          }
        })
        .catch(function () {
          me.$message.error(me.$t("document.requestFail"));
        });
    },

    routerDetail(abilityId){
      this.$router.push({path: '/abilityDetail', query:{id : abilityId}})
    },

    getListByOrder(value){
      this.sortType = value.name;
      //如果能力大类多选框选择，则先清空已选项；清空面包屑；清空搜索框
      this.searchContent = ''
      this.breadcrumbSelectedData =[]
      this.listData.forEach((item) =>{
          item.checkAll = false; // 非接口字段
          item.isIndeterminate = false; // // 非接口字段
          item.isHoverExtend = false; // 非接口字段
          item.isOpenChildren = false; // 非接口字段
          item.checkedChildrenArr = []; // 选中的子元素
          (item.children || []).forEach((childItem) => {
            childItem.isChecked = false;
          });
        })
      this.getSceneListByPage();
    },
  },
};
</script>
<style lang="less" scoped>
.h-page-footer__left {
  width: 100%;
}
::v-deep .el-scrollbar {
  height: calc(~"100% - 25px");
}
::v-deep .list-scrollbar-wrap {
  max-height: 100%;
  overflow-x: hidden;
}
.abilityList {
  width: 100%;
//  background:rgb(253, 246, 246);
  background: #f3f5f8
}
.search-list-wrapper{
    width: 99%;
    // min-height: 400px;
    margin: 0 auto;
    .tabClick {
      padding-right: 10px;
      // background:rgb(253, 246, 246);
       background: #f3f5f8;
      vertical-align: middle;
    }
    .search-breadcrumb-wrapper{
      min-height: 51px;
      padding: 8px 6px;
      user-select: none;
      background: white;
      margin-left: 2px;
      margin-right: 2px;
      border-bottom:1px solid #dad8d8;;
       .el-breadcrumb{
        height: auto;
      }
      .breadcrumb-tag-wrapper{
        max-width: 1360px;
        display: flex;
        flex-wrap: wrap;
      }
      .breadcrumb-tag-text{
        font-size: 14px;
        color: rgba(0,0,0,0.70);
        line-height: 20px;
      }
      .breadcrumb-tag{
        margin: 0 4px;
        margin-bottom: 8px;
        display: block;
        padding: 2px 8px;
        padding-right: 24px;
        position: relative;
        height: 24px;
        min-width: 50px;
        max-width: 260px;
        overflow:hidden;
        text-overflow:ellipsis;
        border: 1px solid rgba(0,0,0,0.12);
        border-radius: 2px;
        .breadcrumb-tag-close{
          width: 24px;
          height: 24px;
          line-height: 24px;
          line-height: 24px;
          padding-left: 3px;
          font-size: 18px;
          position: absolute;
          right: 0px;
          top: 0px;
          opacity: 0.7;
          &:hover{
            cursor: pointer;
            opacity: 1;
          }
        }
      }
    }
  }

.showScene {
  // position: relative;
  margin-left: 100px;
  margin-right: 100px;
  z-index: 10;
  right: 40px;

  .sceneGroupZone {
    margin-top: 15px;
    background: color("#f6f6f6");
    .childrenLabel {
      margin-left: 80px;
    }
  }
  .pageFooter {
    position: relative;
    text-align: center;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 10px;
  }
}
//hicoo-ai的样式
.search-filter-wrapper{
  // width: 1200px;
  // min-height: 50px;
  background: white;
  margin-left: 10px;
  margin-right: 10px;
  // padding: 10px;
  // margin-top: -11px;
  padding-bottom: 12px;
  .filter-content-wrapper {
    width: 100%;
    display: flex;
    padding-top: 10px;
    background: white;
    // margin: 0 10px;
    // margin-top: 16px;

    .filter-content-lable {
      width: 88px;
      padding: 6px 6px;
    }

    .filter-content-selecte-wrapper {
      width: calc(100% - 0px);
      display: flex;
      // background: #F6F6F6;
      .selected-all-btn {
        cursor: pointer;
        background: white;
        width: 62px;
        height: 32px;
        padding: 6px 16px;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.7);
        border: 1px solid #ccc;
        border-radius: 2px;
        &:hover {
          border-color: #095dff;
          background-color: #fff;
          color: #095dff;
          // background: #f0f0f0;
          // color: #4d4d4d;
        }
      }
      .selected-btns-wrapper {
        flex: 1;
        display: flex;
        width: calc(100% - 62px);
        flex-direction: column;
        align-items: center;
        /deep/ .el-checkbox__input {
          margin-top: -2px;
          vertical-align: middle;
        }
      }
      .selected-all-btn_selected {
        border-color: #095dff;
        background-color: #fff;
        color: #095dff;
      }
    }
  }
}
/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: opacity 0.1s 0.15s ease;
}
.slide-fade-leave-active {
  transition: opacity 0.1s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active 用于 2.1.8 以下版本 */ {
  // transform: translateY(-10px);
  opacity: 0;
}
//hicoo-ai样式

.appList {
  padding: 22px 0;
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  .appCard {
    border: 1px solid #e9e9e9;
    // width: calc(~"25% - 20px");
    width: 255px;
    height: 330px;
    margin: 0 12.4px;
    margin-bottom: 20px;
    overflow: hidden;

    .cardInfo {
      padding: 20px;
      display: flex;
      width: 100%;
      transition: 0.5s;
      flex-direction: column;
      background: white;
      .infoTop {
        width: 215px;
        height: 155px;
        img {
          width: 216px;
          height: 144px;
        }
        border-bottom:1px dashed #aeaeae
      }
      .infoEnd {
        margin-top: 8px;
        display: flex;
        flex-direction: column;
        width: 217px;
        // height: 169px;
        .abilityDescription{
          margin-top: 5px;
          color: #aeaeae;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          width: 217px;
          height: 38px;
        }
        .openWays {
          display: inline-block;
           height: 64px;
          .el-tag {
            margin-right: 8px;
            margin-top: 8px;
          }
        }
        .pic {
          display: inline-block;
          position: relative;
          width:100px;
          height: 100px;
          bottom: 80px;
          left:160px
        }
        .read {
          display: inline-block;
          position: relative;
          width:70px;
          height: 25px;
          bottom: 105px;
          vertical-align: middle;
            .readNum {
            display: inline-block;
            position: relative;
            bottom: 6px;
            color: #aeaeae;
          }
        }

      }
      .hide {
        margin-left: 18px;
      }
    }
  }
}
.page-appManege-icon {
  min-width: 24px;
  font-size: 24px;
  vertical-align: middle;
  line-height: 0;
}
.el-pagination {
  text-align: center;
  margin-bottom: auto;
}

.showDetail {
  padding: 17px;
  margin-left: 300px;
  margin-right: 300px;
}

.showAnchor {
  position: fixed;
  z-index: 10;
  top: 100px;
  right: 40px;
  max-height: 80%;
  overflow: auto;
}
.btn-p {
  margin-top: 5px;
}
.breakcrumbStyle {
  margin-left: 310px;
  margin-right: 332px;
}

.table-margin {
  background: #fff;
}
.example-container {
    overflow: auto;
    word-break: break-all;
}
.nodata {
  width: 180px;
  height: 170px;
  align-items:center;
}
.searchSceneAbility {
  width: 290px;
  height: 32px;
  border-top-right-radius:10px;
  border-top-left-radius:10px;
  border-bottom-left-radius:10px;
  border-bottom-right-radius:10px;
}
</style>
